import React, { useEffect, useState } from "react";
import Modal1 from "../DIsplay/Modal/Modal1";
import { enqueueSnackbar } from "notistack";
import cancelPackageBooking from "../../controllers/tourPackage/cancelPackageBooking";
import cancelAndRefundPackageBooking from "../../controllers/tourPackage/cancelAndRefundPackageBooking";
import packageCancellationQuote from "../../controllers/tourPackage/packageCancellationQuote";

function CancelPackageModal({ open, setOpen, booking }) {
  const [loading, setLoading] = useState();
  const isPaid = ["Paid", "Issued", "Completed", "Ticket issued"].includes(
    booking?.status,
  );
  const [qouteLoading, setQuoteLoading] = useState(false);
  const [canRefund, setCanRefund] = useState(false);
  const [finalRefund, setFinalRefund] = useState(false);

  const handleCancelPackageOrder = async () => {
    setLoading(true);
    const res = isPaid
      ? await cancelAndRefundPackageBooking(booking?._id).finally(() =>
          setLoading(false),
        )
      : await cancelPackageBooking(booking?._id).finally(() =>
          setLoading(false),
        );

    if (res?.return) {
      enqueueSnackbar("Package cancelled successful", {
        variant: "success",
      });
      window.location.reload();
    } else {
      enqueueSnackbar(res?.msg, { variant: "error" });
    }
  };

  const loadCancellationQuote = async () => {
    if (!isPaid) return;

    setQuoteLoading(true);
    const res = await packageCancellationQuote(booking?._id).finally(() =>
      setQuoteLoading(false),
    );

    if (res?.return) {
      const data = res?.data;
      setCanRefund(data?.canRefund);
      setFinalRefund(data?.finalRefund);
    } else {
      enqueueSnackbar(res?.msg, { variant: "error" });
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      loadCancellationQuote();
    }
  }, [open]);

  return (
    <Modal1 open={open} setOpen={setOpen}>
      <div className="p-6 flex flex-col items-center text-center lg:min-w-[500px]">
        {qouteLoading ? (
          <div className="w-full flex flex-col items-center gap-4 animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="h-10 bg-gray-200 rounded w-full mt-4"></div>
          </div>
        ) : (
          <>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Cancel {isPaid ? " and Refund Order" : "Booking"}?
            </h2>

            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to cancel this order? This action cannot be
              undone.
            </p>

            {/* Paid cases */}
            {isPaid && canRefund && (
              <p className="text-sm text-gray-700 mb-3">
                Final Refund:{" "}
                <span className="font-semibold">{finalRefund}</span>
              </p>
            )}

            {isPaid && !canRefund && (
              <p className="text-sm text-red-600 mb-4">
                This booking is not eligible for refund.
              </p>
            )}

            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="w-full sm:w-1/2 border border-gray-300 text-gray-700 rounded-md py-2.5 text-sm font-medium hover:bg-gray-50 transition"
              >
                {isPaid && !canRefund ? "Close" : "No"}
              </button>

              {/* Show cancel button only when allowed */}
              {isPaid ? (
                canRefund && (
                  <button
                    type="button"
                    onClick={handleCancelPackageOrder}
                    className="w-full sm:w-1/2 bg-red-600 text-white rounded-md py-2.5 text-sm font-medium hover:bg-red-700 transition flex items-center justify-center"
                  >
                    {loading ? (
                      <div className="buttonLoader"></div>
                    ) : (
                      <>Yes, Cancel Request</>
                    )}
                  </button>
                )
              ) : (
                <button
                  type="button"
                  onClick={handleCancelPackageOrder}
                  className="w-full sm:w-1/2 bg-red-600 text-white rounded-md py-2.5 text-sm font-medium hover:bg-red-700 transition flex items-center justify-center"
                >
                  {loading ? (
                    <div className="buttonLoader"></div>
                  ) : (
                    <>Yes, Cancel Request</>
                  )}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </Modal1>
  );
}

export default CancelPackageModal;
